import { useIntl } from "react-intl";

import { useOldCustomTexts } from "hooks/CustomTextsHooks";
import { useMatches } from "@tanstack/react-router";

/** Get the static page title defined for the current route or the closest matching route. */
export function useStaticRouteTitle(): string | undefined {
  const intl = useIntl();
  const { data: customTexts } = useOldCustomTexts();
  const matches = useMatches();
  const pageTitle = matches[matches.length - 1].staticData.pageTitle;
  return typeof pageTitle === "object"
    ? intl.formatMessage(pageTitle, { ...customTexts })
    : pageTitle;
}
